// extracted by mini-css-extract-plugin
export var editContainer = "index-module--editContainer--Hr5BE";
export var btnCustomizeAvatar = "index-module--btnCustomizeAvatar--SIpn2";
export var avatarContainer = "index-module--avatarContainer--EaT1n";
export var avatarSelector = "index-module--avatarSelector--MDNKW";
export var avatar = "index-module--avatar--rhpZ2";
export var enterNameContainer = "index-module--enterNameContainer--uPsLd";
export var randomContainer = "index-module--randomContainer--lT6Uj";
export var error = "index-module--error--RtEoe";